var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFill1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 6,
    viewBox: "0 0 5 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0057A0",
    fillRule: "evenodd",
    d: "M4.787 3.235a.336.336 0 0 0 0-.513L1.477.121a.326.326 0 0 0-.528.256V5.58a.326.326 0 0 0 .527.256l3.31-2.601z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill1);
export default __webpack_public_path__ + "static/media/fill-1.3f990860726063bc40c02d103d4545be.svg";
export { ForwardRef as ReactComponent };